"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/contracts/dex/constants.ts
var DEX_VERSION = {
  v1: "v1",
  v2_1: "v2_1",
  v2_2: "v2_2"
};
var DEX_TYPE = {
  CPI: "constant_product"
};




exports.DEX_VERSION = DEX_VERSION; exports.DEX_TYPE = DEX_TYPE;
//# sourceMappingURL=chunk-NE5AG7IW.cjs.map